import { allowAction } from "helpers/common";
import { useContext } from "react";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { useAuth0 } from "@auth0/auth0-react";

export const useAllowedPermissions = () => {
  const { user } = useAuth0();
  const { userPermissions } = useContext(PermissionsContext);

  const isAllowedAction = (ownerId, permissions) => {
    if (typeof permissions === "string") {
      return allowAction(user?.cxfUserId, ownerId, userPermissions, permissions);
    }

    const foundPermission = permissions.find((permission) =>
      allowAction(user?.cxfUserId, ownerId, userPermissions, permission)
    );

    return !!foundPermission;
  };

  return {
    isAllowedAction,
  };
};
